import { configureStore } from "@reduxjs/toolkit";
import designerReducer from './slices/designerSlice';
import inspectorReducer from './slices/inspectorSlice';
import sectionsReducer from './slices/sectionsSlice';

const store = configureStore({
  reducer: {
    designer: designerReducer,
    inspector: inspectorReducer,
    sectionStore: sectionsReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;